module.exports = __webpack_public_path__ + "b2_schild.0b1cb182f3af7563f11656b76f8a7a4d.png";